import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "发票邮寄")
], -1)
const _hoisted_2 = { class: "form-dialog__content" }

import { BaseForm, BaseFormItem, BaseInput } from 'xrk-components';
import { InvoiceApplyDTO } from '@V/invoice/src/data-source/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-detail-dialog-address',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const formData = _useModel<InvoiceApplyDTO>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref: "formRef",
    "label-position": "top",
    disabled: "",
    model: formData.value
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BaseFormItem), {
          label: "收件人",
          prop: "receiptFullName"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              modelValue: formData.value.receiptFullName
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "联系电话",
          prop: "receiptPhone"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              modelValue: formData.value.receiptPhone
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "企业地址",
          prop: "invoiceEnterpriseAddress"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              modelValue: formData.value.invoiceEnterpriseAddress
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "邮箱",
          prop: "email"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "tel",
              placeholder: "请输入",
              modelValue: formData.value.email
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})